import React, { useState, useEffect,useRef } from 'react';
import AxiosInstance from '../AxiosInstance';
import ELayout from './ELayout';
import { useNavigate, useLocation } from 'react-router-dom';
import ToastNotification from '../ToastNotification';

const WeeksTimesheet = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedMonth, setSelectedMonth] = useState(
        location.state?.selectedMonth || new Date().toISOString().slice(0, 7)
    );
    const [timesheetData, setTimesheetData] = useState(
        location.state?.timesheetData || []
    );
    const employeeId = localStorage.getItem('employeeId');
    const toastRef = useRef(null);

    useEffect(() => {
        if (employeeId) {
            fetchTimesheetData();
        }
    }, [selectedMonth, employeeId]);
    
    const fetchTimesheetData = async () => {
        if (!employeeId) {
            toastRef.current?.showToast("Employee ID is missing in localStorage","danger");
            return;
        }

        try {
            const [year, monthOnly] = selectedMonth.split('-');
            console.log(`Fetching from API: /employee/weeksTimesheetStatus with year=${year}, month=${monthOnly}, employee_id=${employeeId}`);

            const response = await AxiosInstance.post(`/employee/weeksTimesheetStatus`, {
                month: monthOnly, 
                year: year,
                employee_id: employeeId 
            });
            
            setTimesheetData(response.data.data || []);
        } catch (error) {
             toastRef.current?.showToast("Error fetching timesheet data:","danger");
        }
    };
    
    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
    
        return `${month}-${day}-${year}`;
    };

    const dateFormat = (date) => {
        const d = new Date(date);
        return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
      };
   
    return (
        <ELayout heading="Timesheet">
            <div className="container mt-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="me-2">
                        <label className="me-2">Select Month:</label>
                        <input 
                            type="month" 
                            value={selectedMonth} 
                            onChange={handleMonthChange} 
                            className="form-control w-auto d-inline-block" 
                        />
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-hover text-center align-middle table-striped">
                        <thead className="table-primary">
                            <tr>
                                <th scope="col">#</th>
                                <th>Week Start Date</th>
                                <th>Week End Date</th>
                                <th>Status</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                        {timesheetData.length > 0 ? (
                            timesheetData.map((week, index) => (
                                <tr
                                        key={index}
                                        onClick={() => {
                                            let mode = "";

                                            if (week.status === "Accepted" || week.status === "Submitted") {
                                                mode = "readonly";
                                            } else if (week.status === "Not Submitted") {
                                                mode = "new";
                                            } else if (week.status === "Saved") {
                                                mode = "edit";
                                            } else if (week.status === "Rejected") {
                                                mode = "rejected";
                                            }

                                            const formattedWeek = {
                                                week_start: dateFormat(week.week_start),
                                                week_end: dateFormat(week.week_end),
                                              };
                                            navigate('/timesheetTable', {
                                                state: {
                                                    week: formattedWeek,
                                                    mode,
                                                    fromPageState: {
                                                        selectedMonth,
                                                        timesheetData,
                                                    },
                                                },
                                            });
                                        }}
                                        style={{
                                            cursor: "pointer",
                                        }}
                                    >
                                    <td>{index + 1}</td>
                                    <td>{formatDate(week.week_start)}</td>
                                    <td>{formatDate(week.week_end)}</td>
                                    <td
                                     style={{
                                        color:
                                          week.status === "Not Submitted"
                                            ? "red"
                                            : week.status === "Rejected"
                                            ? "blue"
                                            : week.status === "Saved"
                                            ? "orange"
                                            : week.status === "Accepted"
                                            ? "black"
                                            : "green", 
                                        fontWeight: "bold",
                                      }}                                      
                                    >
                                    {week.status}
                                    </td>
                                    <td>
                                    {week.status === "Rejected" ? (week.rejection_reason || "N/A") : "N/A"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6">No data available</td>
                            </tr>
                        )}
                    </tbody>
                    </table>
                </div>
                <ToastNotification ref={toastRef} />
            </div>
        </ELayout>
    );
};

export default WeeksTimesheet;
